import { Box, Typography, useMediaQuery } from "@mui/material";
import { MahaloParticipantIcon } from "../../../Common/assets/Sidebar";
import { rowFlexStyle } from "../../../Common/styles/flex";
// import { ChevronLeft } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../../Redux/hooks";

const ConsentFormHeader: React.FC = () => {
  const consentName = useAppSelector(
    (state) => state.providerConsent.consentName
  );
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:900px)");

  // const handleBack = () => {
  //   navigate(-1);
  // };

  const navigateToHome = () => {
    navigate("/home");
  };

  return (
    <Box
      sx={{
        height: "80px",
        position: "sticky",
        top: 0,
        width: "100%",
        ...rowFlexStyle,
        alignItems: "center",
        justifyContent: "center",
        px: 2.5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          position: "absolute",
          left: "20px",
        }}
      >
        {/* <IconButton onClick={handleBack}>
          <ChevronLeft />
        </IconButton> */}
        <Box
          onClick={navigateToHome}
          sx={{
            cursor: "pointer",
          }}
        >
          <MahaloParticipantIcon />
        </Box>
      </Box>
      {!isMobile && consentName && (
        <Typography
          fontSize={30}
          fontWeight="bold"
          sx={{
            maxWidth: "70%",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          {consentName}
        </Typography>
      )}
    </Box>
  );
};

export default ConsentFormHeader;
